export default function PrivacyPolicy({ language}) {

    return (
        <section className="w-full bg-[#fffaf0] py-16 px-6 md:px-12">
            <h2 className="text-3xl font-bold mb-6 text-center">
                {language === "JP" ? "プライバシーポリシー" : language === "ZH" ? "隐私政策" : "Privacy Policy"}
            </h2>

            <div className="max-w-5xl mx-auto">
                <p className="mb-2">{language === "JP" ? "施行日" : language === "ZH" ? "生效日期：" : "Effective Date"}: 2026.02.21</p>
                <p>{language === "JP" ? "最終更新日" : language === "ZH" ? "最后更新：" : "Last Updated"}: 2026.02.21</p>

                <p className="mt-4">
                    {language === "JP"
                        ? "本プライバシーポリシーは、株式会社ふじやま（以下「当社」）が本サービスの利用者（以下「ユーザー」）からどのように情報を収集・利用するかを説明するものです。本プライバシーポリシーにおける「サービス」とは、当社ウェブサイト（official-fujiyama.com）（以下「本サイト」）を指します。本プライバシーポリシーは、当社が下記にて収集・利用・開示・保存するユーザー情報に適用されます。"
                        : language === "ZH"
                            ? "本隐私政策说明Fujiyama, Inc.（以下简称“我们”） 如何收集、使用、披露及存储使用本服务或与我们互动的用户（以下简称“您”）的信息。本政策所称“服务”，指我们运营的官方网站（official-fujiyama.com）（以下简称“本网站”）。本政策适用于我们通过本网站、您与我们的电子通信等方式收集、处理及保管的全部用户信息。"
                            : "This Privacy Policy explains how Fujiyama, Inc. collects and uses information from people who use our Service or interact with us (“users”). In this policy, “Service” refers to our website (official-fujiyama.com) (the “Site”). Fujiyama, Inc. may also be referred to as “we,” “us,” or “our.” This policy applies to information we collect, use, disclose, and store about users:"}
                </p>

                    <ul className="list-disc pl-6">
                        <li>{language === "JP" ? "当ウェブサイト" : language === "ZH" ? "本网站" : "On our website"}</li>
                        <li>{language === "JP" ? "ユーザーと当社間の電子通信" : language === "ZH" ? "用户与我们之间的电子通信" : "In email or other electronic communications between users and us"}</li>
                    </ul>

                    <h2 className="font-bold text-xl mt-3">
                        {language === "JP" ? "子どものプライバシー" : language === "ZH" ? "儿童隐私" : "Children"}
                    </h2>

                    <p>
                        {language === "JP"
                            ? "本サービスは一般利用者向けであり、大人および子どもがアクセスする可能性があります。当社は子どものプライバシー保護の重要性を認識しております。"
                            : language === "ZH"
                                ? "本服务面向大众用户，成人和儿童均可能访问。我们重视保护儿童隐私。"
                                : "Our Service is intended for a general audience and may be accessed by both adults and children. We recognize the importance of protecting children’s privacy."}
                    </p>

                    <p>
                        {language === "JP"
                            ? "13歳未満の子どもから故意に個人情報を収集することはありません。個人情報の提出が必要な機能は、13歳以上のユーザー、または保護者が子どもに代わって利用することを想定しています。"
                            : language === "ZH"
                                ? "我们不会故意收集13岁以下儿童的个人信息。如某些功能需要提交个人信息，则仅适用于13岁以上用户或由监护人代为提交。"
                                : "We do not knowingly collect personal information directly from children under 13. If a feature requires submission of personal information, it is intended for users aged 13 or older or for parents or guardians acting on behalf of a child."}
                    </p>

                    <p>
                        {language === "JP"
                            ? "万一、適切な許可なく13歳未満の子どもの個人情報を取得していたことが判明した場合、速やかに削除します。"
                            : language === "ZH"
                                ? "如果发现我们在未经适当授权的情况下收集了13岁以下儿童的个人信息，我们将立即删除。"
                                : "If we become aware that we have unintentionally collected personal information from a child under 13 without appropriate authorization, we will promptly delete such information."}
                    </p>

                    <h2 className="font-bold text-xl mt-3">
                        {language === "JP" ? "収集する情報" : language === "ZH" ? "我们收集的信息" : "Information We Collect"}
                    </h2>

                    <h3 className="font-bold text-l mt-2">
                        {language === "JP" ? "1. 自動的に収集される情報" : language === "ZH" ? "1. 自动收集的信息" : "1. Information Collected Automatically"}
                    </h3>

                    <p>
                        {language === "JP"
                            ? "サービス利用時、運営・分析目的のために一部情報が自動収集される場合があります。例："
                            : language === "ZH"
                                ? "当用户使用服务时，可能会出于运营和分析目的自动收集部分信息，例如："
                                : "When users use our Service, certain limited information may be collected automatically for internal operational and analytics purposes. This may include:"}
                    </p>

                    <ul className="list-disc pl-6">
                        <li>{language === "JP" ? "IPアドレス" : language === "ZH" ? "IP地址" : "IP address"}</li>
                        <li>{language === "JP" ? "ブラウザ・端末情報" : language === "ZH" ? "浏览器和设备信息" : "Browser type and device information"}</li>
                        <li>{language === "JP" ? "閲覧ページ・滞在時間" : language === "ZH" ? "访问页面和停留时间" : "Pages visited and time spent on pages"}</li>
                        <li>{language === "JP" ? "参照元サイト" : language === "ZH" ? "来源网站" : "Referring website"}</li>
                        <li>{language === "JP" ? "大まかな地域情報" : language === "ZH" ? "大致地理位置" : "General geographic region"}</li>
                    </ul>

                    <p>
                        {language === "JP"
                            ? "これらは解析ツールやサーバーログにより収集され、サイト改善・安全維持・運営目的のみに使用されます。個人特定には使用しません。"
                            : language === "ZH"
                                ? "这些信息通过分析工具和服务器日志收集，仅用于性能分析、体验优化、安全维护及服务运营，不会用于识别个人身份。"
                                : "This information is collected through analytics tools and server logs and is used only to understand website performance, improve user experience, maintain security, and operate the Service. We do not use this information to personally identify users."}
                    </p>

                    <h3 className="font-bold text-l mt-2">
                        {language === "JP" ? "2. 任意で提供される情報" : language === "ZH" ? "2. 用户主动提供的信息" : "2. Information Users Provide Voluntarily"}
                    </h3>

                    <p>
                        {language === "JP"
                            ? "お問い合わせフォーム利用時など、ユーザーが任意で提供した場合のみ個人情報を収集します。例："
                            : language === "ZH"
                                ? "仅当用户主动提供时（例如填写联系表单）我们才会收集个人信息，例如："
                                : "We collect personal information only when users choose to provide it, such as when you contact us through our contact form. This may include:"}
                    </p>

                    <ul className="list-disc pl-6">
                        <li>{language === "JP" ? "氏名" : language === "ZH" ? "姓名" : "Name"}</li>
                        <li>{language === "JP" ? "メールアドレス" : language === "ZH" ? "电子邮箱" : "Email address"}</li>
                        <li>{language === "JP" ? "お問い合わせ内容" : language === "ZH" ? "留言内容" : "Message content"}</li>
                    </ul>

                    <p>
                        {language === "JP"
                            ? "これらの情報はお問い合わせ対応の目的のみに使用されます。"
                            : language === "ZH"
                                ? "这些信息仅用于回复用户的咨询。"
                                : "We use this information solely to respond to the user's inquiry or request."}
                    </p>

                    <h2 className="font-bold text-xl mt-3">
                        {language === "JP" ? "アクセス解析" : language === "ZH" ? "数据分析" : "Analytics"}
                    </h2>

                    <p>
                        {language === "JP"
                            ? "当サイトでは訪問状況を理解するため解析サービスを利用しています。解析データは統計・性能分析目的のみに使用され、広告やプロファイリングには利用しません。"
                            : language === "ZH"
                                ? "我们使用网站分析服务了解访客行为。数据仅用于统计和性能分析，不用于广告或用户画像。"
                                : "We use a website analytics service to understand how visitors interact with our site. Analytics data is used only for internal statistical and performance purposes. We do not use analytics for advertising, profiling, or behavioral tracking."}
                    </p>

                    <h2 className="font-bold text-xl mt-3">
                        {language === "JP" ? "情報の利用目的" : language === "ZH" ? "信息使用方式" : "How We Use Information"}
                    </h2>

                    <ul className="list-disc pl-6">
                        <li>{language === "JP" ? "お問い合わせ対応" : language === "ZH" ? "回复咨询" : "Respond to inquiries or support requests"}</li>
                        <li>{language === "JP" ? "サイト運営・維持" : language === "ZH" ? "网站运营维护" : "Maintain and operate the website"}</li>
                        <li>{language === "JP" ? "機能改善" : language === "ZH" ? "改进功能" : "Monitor performance and improve functionality"}</li>
                        <li>{language === "JP" ? "安全対策" : language === "ZH" ? "安全防护" : "Protect security and prevent misuse"}</li>
                    </ul>

                    <p>
                        {language === "JP"
                            ? "当社は個人情報を販売・貸与しません。"
                            : language === "ZH"
                                ? "我们不会出售或出租个人信息。"
                                : "We do not sell or rent users’ personal information."}
                    </p>

                    <h2 className="font-bold text-xl mt-3">
                        {language === "JP" ? "お問い合わせ" : language === "ZH" ? "联系我们" : "Contact Us"}
                    </h2>

                    <p>
                        {language === "JP"
                            ? "本プライバシーポリシーに関する質問や情報の削除・修正依頼は以下へご連絡ください。"
                            : language === "ZH"
                                ? "如需咨询或请求删除或更正信息，请联系："
                                : "If you have questions about this Privacy Policy or wish to request access, correction, or deletion of your information, contact:"}
                    </p>

                    <p>privacy@official-fujiyama.com</p>

                </div>
        </section>
    );
}
